import {
    AWSErmineServerSideRenderingServiceClient,
    CreateRemoteBrowserCommand,
    CreateRemoteBrowserCommandInput,
    GetCookieSynchronizationConfigurationCommand,
    GetCookieSynchronizationConfigurationCommandInput,
    GetTermsOfServiceCommand,
    GetTermsOfServiceCommandInput,
    GetUserCommand,
    SignOutCommand,
    SendClientMessageCommand,
    SendClientMessageCommandInput,
} from "@amzn/ermine-server-side-rendering-client";
import { XhrHttpHandler } from "@aws-sdk/xhr-http-handler";

import { getPortalEndpoint } from "./configurationUtils";

let ermineSsrServiceClient: AWSErmineServerSideRenderingServiceClient;

export const getErmineSsrClient = () => {
    if (ermineSsrServiceClient != null) {
        return ermineSsrServiceClient;
    }

    const portalEndpoint =
        process.env.NODE_ENV === "development"
            ? window.location.origin
            : getPortalEndpoint();

    ermineSsrServiceClient = new AWSErmineServerSideRenderingServiceClient({
        endpoint: portalEndpoint,
        maxAttempts: 1,
        customUserAgent: "aws-ermine-ssr-client/1.0.0",
        requestHandler: new XhrHttpHandler({}), // overrides default FetchHttpHandler in browsers (Ticket: https://t.corp.amazon.com/V1704142461)
    });

    return ermineSsrServiceClient;
};

export const sendCreateRemoteBrowserCommand = (
    input: CreateRemoteBrowserCommandInput
) => getErmineSsrClient().send(new CreateRemoteBrowserCommand(input));

export const sendGetTermsOfServiceCommand = (
    input: GetTermsOfServiceCommandInput
) => getErmineSsrClient().send(new GetTermsOfServiceCommand(input));

export const sendSignOutCommand = () =>
    getErmineSsrClient().send(new SignOutCommand());

export const sendGetUserCommand = () =>
    getErmineSsrClient().send(new GetUserCommand());

export const sendGetCookieSynchronizationConfigurationCommand = (
    input: GetCookieSynchronizationConfigurationCommandInput
) =>
    getErmineSsrClient().send(
        new GetCookieSynchronizationConfigurationCommand(input)
    );

export const sendSendClientMessageCommand = (
    input: SendClientMessageCommandInput
) => getErmineSsrClient().send(new SendClientMessageCommand(input));
